export default __webpack_public_path__ + "2cc15f134b603e2199ef69387a51a32f.png";